import script from "./homepage.vue?vue&type=script&setup=true&lang=ts"
export * from "./homepage.vue?vue&type=script&setup=true&lang=ts"

import "./homepage.vue?vue&type=style&index=0&id=6ba169aa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba169aa"]])

export default __exports__